import * as React from "react";
import Link from "components/Link";
import { graphql, StaticQuery } from "gatsby";

import DataProvider from "providers/data";

import { whitelist } from "constants/mobile-footer-whitelist";

const Column = ({ menuArr }) => {
	return (
		!!menuArr.length && (
			<ul>
				{menuArr.map((i, index) =>
					!JSON.parse(i.visible) ? null : (
						<li key={`footer-link-${i.text.toLowerCase()}`}>
							<Link to={i.href}>
								{i.text}
							</Link>
						</li>
					))}
			</ul>)
	)
}

const FooterNavigationHandler = (props) => (
	<StaticQuery
		query={graphql`
			{
				allContentMenu(filter: { menuID: { eq: "footer" } }) {
					edges {
						node {
							pages
						}
					}
				}
			}
		`}
		render={(data) => {
			const { edges: menuEdges } = data.allContentMenu;
			let footerMenu = menuEdges.map(({ node }) => node.pages)[0];
			if ((props.providerResponse.data.length > 0 || !!footerMenu !== false) && props.providerStatusText === "LOADED") {
				footerMenu = props.providerResponse.data.filter(
					(datum) => datum.menuID === "footer"
				)[0].pages;
			}

			if (whitelist.length && props.location === "offcanvas") footerMenu = footerMenu.filter((item) => whitelist.includes(item.text));

			const firstCol = footerMenu.slice(0, 4);
			const secondCol = footerMenu.slice(4);

			return (
				<>
					<Column key={`footer-col-1`} {...{ menuArr: firstCol }} />
					<Column key={`footer-col-2`} {...{ menuArr: secondCol }} />
				</>
			);
		}}
	/>
);

const FooterNavigation = (props) => {
	return (
		<DataProvider liveRefresh={true} type="ContentMenu">
			<FooterNavigationHandler {...props} />
		</DataProvider>
	);
};

export default FooterNavigation;
